import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';


import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';

import { newMessage } from '../../slices/modalSlice';
import Autocomplete from './searchAutoComplete';
import axios from 'axios';
import { messages } from '../../slices/messageSlice';
import {io} from "socket.io-client"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';

class NewMessage extends Component {

    constructor(props) {
        super(props);
        this.state = {
          users : [],
          names : [],
          chosenUser  : "",
          enteredMessage : "",
          convId : "",
          user : this.props.currentUser,
          conversations : []
        }
        this.socket = React.createRef(io("ws://localhost:8900"));
      }
 

      getUsers = async () => {
        try {
          const host  = process.env.REACT_APP_SERVER_URL
          const res = await axios.get(`${host}/api/users`)
         console.log(res);
         const users = res.data.filter((user) => user._id !== this.state.user._id);
          this.setState({users : users})

        } catch (error) {
          console.log(error);
        }
      }
      

    toogleClose = () =>this.props.dispatch(newMessage())



    

    createConversation = async (e,recieverId) =>{
     e.preventDefault()
      const newConversation = {
        senderId : this.state.user._id,
        recieverId : recieverId
      }

    
   
     
   
    
      try {
        const host  = process.env.REACT_APP_SERVER_URL
        const res = await axios.post(`${host}/api/conversations`, newConversation)
        console.log(res.data._id);
        await this.setState({convId : res.data._id})
        console.log(this.state.convId);
       

    
      } catch (error) {
        console.log(error);
      }
    }
    pushMessage = async (e) =>{
      e.preventDefault()
      
       
      const newMessage = await {
            sender : this.state.user._id,
            conversationId : this.state.convId,
            message : this.state.enteredMessage
        }
     
    
        this.socket.current.emit("sendMessage",{
          senderId : this.state.user._id,
          recieverId : this.state.chosenUser,
          text : this.state.enteredMessage
       })

    
     
       try {
         
        console.log(this.state.convId);
        const host  = process.env.REACT_APP_SERVER_URL
         const resMsg = await axios.post(`${host}/api/messages`, newMessage)
         console.log(resMsg.data);
         const resConv = await axios.get(`${host}/api/messages/`+this.state.convId)
         console.log(resConv.data);
         this.props.history.push(`/messagerie/`+this.state.convId.toString()); 
         
          this.props.dispatch(messages(resMsg.data))
 
     
       } catch (error) {
         console.log(error);
       }
     }
    handleMessage (e){
      e.preventDefault()
      this.setState({enteredMessage : e.target.value})
    }

    


    sendMessage = async(e) => {
      e.preventDefault()
      const host  = process.env.REACT_APP_SERVER_URL
      if (this.state.chosenUser !== ""){
      const existConv = await axios.get(`${host}/api/conversations/users/`+this.state.user._id+"/"+this.state.chosenUser)

      if (existConv.data.length === 0){
        await this.createConversation(e,this.state.chosenUser)
        await  this.pushMessage(e)
      }
      else {
       await this.setState({convId : existConv.data[0]._id})
       await console.log(this.state.convId);
      await this.props.history.push("/messagerie/"+this.state.convId.toString()); 
        await this.pushMessage(e)
      }
      
        this.toogleClose()
       
      }
    }

    componentDidMount (){
      this.socket.current =  io("ws://localhost:8900")
      this.setState({chosenUser : this.props.announcer})
     this.getUsers()

   }

 
    render() {
      console.log(this.props.announcer);
      const  eventhandler = data => this.setState({chosenUser : data.userId})
   

 
        return (
            <div>
              <Modal isOpen={this.props.newMessage} toggle={this.toogleClose} className="modal-width-addAnnoun" size="md">

                    <nav className="nav-windows-addanounce mb-3">
                    <button className="close-heberg"  onClick={this.toogleClose} >
                      <span><FontAwesomeIcon icon={faTimes}/></span>
                    </button>
                      <div className="title-announce">Rédiger un message</div>
                    </nav>

   
                   <ModalBody className="container">
                     <div className="d-flex ">
                        <h3 className='nvl__text col-1  pl-0'>Nom</h3>
                        <Autocomplete  suggestions={this.state.users.map((user) => user)} onChange={eventhandler} />
                        {eventhandler.userId !== "" && (
                          <h4>{eventhandler.userId}</h4>
                        )}
                     </div>
                     <div className="d-flex mt-4">
                        <h3 className='nvl__text col-1 pl-0'>texte</h3>
                        <textarea type="text" name="message" placeholder='Bonjour...' id="message" className='col nvl__input_area ml-2' onChange={(e) => this.handleMessage(e)} />
                     </div>
                     <div className="d-flex justify-content-end mt-3">
                        <Button className='mr-2 nvl__btns nvl__cancel' onClick={this.toogleClose}>Annuler</Button>
                        <Button className='nvl__btns nvl__send' type='submit' onClick={(e)=> this.sendMessage(e)}>Envoyer <FontAwesomeIcon icon={faChevronRight}/></Button>
                     </div>
                     
                     
         
                   </ModalBody>
              </Modal>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
    
      newMessage: state.modal.newMessage,
      announcer : state.modal.announcer
      
    }
  }
export default withRouter(connect(mapStateToProps)(NewMessage));
